import React from 'react';
import { Tabs } from 'antd';
import {
  UserOutlined,
  MedicineBoxOutlined,
  TeamOutlined,
  DollarCircleOutlined,
  FormOutlined
} from '@ant-design/icons';

import Doctors from '../Doctors';
import Billers from '../Billers';

import Reviewers from '../Reviewers';
import Admins from '../Admins';
import Scribes from '../Scribes';
import CustomTypography from '../../CustomComponents/CustomTypography';
import PageTitle from '../../../Utils/PageTitle';
import { StyledTabs } from './styledComponents';
const { TabPane } = Tabs;
const UsersPage = () => {
  return (
    <>
      <PageTitle title='Doctors' />

      <StyledTabs defaultActiveKey='admins' type='card'>
        <TabPane
          key='admins'
          tab={
            <span>
              <UserOutlined /> Admins
            </span>
          }
        >
          <Admins />
        </TabPane>

        <TabPane
          key='doctors'
          tab={
            <span>
              <MedicineBoxOutlined /> Providers
            </span>
          }
        >
          <Doctors />
        </TabPane>

        <TabPane
          key='scribes'
          tab={
            <span>
              <FormOutlined /> Scribes
            </span>
          }
        >
          <Scribes />
        </TabPane>

        <TabPane
          key='reviewers'
          tab={
            <span>
              <TeamOutlined /> Reviewers
            </span>
          }
        >
          <Reviewers />
        </TabPane>

        <TabPane
          key='billers'
          tab={
            <span>
              <DollarCircleOutlined /> Billers
            </span>
          }
        >
          <Billers />
        </TabPane>
      </StyledTabs>
    </>
  );
};
export default UsersPage;
